import { render } from "./guarantee.vue?vue&type=template&id=17c6542d&scoped=true&ts=true"
import script from "./guarantee.vue?vue&type=script&lang=ts"
export * from "./guarantee.vue?vue&type=script&lang=ts"

import "./guarantee.vue?vue&type=style&index=0&id=17c6542d&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c6542d"]])

export default __exports__